









































import Vue from 'vue';

import { useSave } from '@/composables';
import { BaseModuleEditor } from '../base';
import StreamsEditor from '../video-conferencing/StreamsEditor.vue';
import ConditionalEditorContainer from '../components/ConditionalEditorContainer.vue';

export default Vue.extend({
  name: 'VideoConferencingEditor',
  components: {
    StreamsEditor,
    ConditionalEditorContainer,
  },
  mixins: [BaseModuleEditor],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props: any) {
    const { buffer, save } = useSave(props, {
      path: 'videoConferencing',
    });

    return {
      buffer,
      save,
    };
  },
});
